import { render, staticRenderFns } from "./ExplorationModal.vue?vue&type=template&id=6d8148b7&scoped=true"
import script from "./ExplorationModal.vue?vue&type=script&lang=js"
export * from "./ExplorationModal.vue?vue&type=script&lang=js"
import style0 from "./ExplorationModal.vue?vue&type=style&index=0&id=6d8148b7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8148b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8148b7')) {
      api.createRecord('6d8148b7', component.options)
    } else {
      api.reload('6d8148b7', component.options)
    }
    module.hot.accept("./ExplorationModal.vue?vue&type=template&id=6d8148b7&scoped=true", function () {
      api.rerender('6d8148b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/exploration/ExplorationModal.vue"
export default component.exports